import axios from "utils/axios";

// API : v1/ai/admin/web/rephrase
export async function AIRephrase(data) {
    try {
        return await axios.post(`ai/admin/web/rephrase`, data);
    } catch (error) {
        return error
    }
}

interface UiComponentsParams {
  type: string;
  route: string;
  subRoute?: string;
}

export async function getUiComponentsData({ type, route, subRoute }: UiComponentsParams) {
    try {
        return await axios.get(`uiComponents/getByRoute/${type}/${route}${subRoute ? `/${subRoute}` : ''}`);
    } catch (error) {
        return error;
    }
}